<template>
  <div
    class="page diagnosis-index"
  >
    <div class="page__sidebar">
      <diagnosis-side-bar
        :counters="sidebarSummary"
        @update-option="onClickUpdateFilter($event)"
        @click-add-filter="onClickAddFilter"
        @view-all-toggled="onViewAllToggled"
        @view-responsibility-changed="onViewResponsibilityChanged"
      />
    </div>
    <div
      v-if="loaded"
      class="page__main"
    >
      <router-view
        :key="$route.path"
        ref="mainContent"
        class="page__main-content"
        @updateSummary="loadSidebarSummary"
      />
    </div>
  </div>
</template>

<script>
import DiagnosisSideBar from './sideBar/DiagnosisSideBar'
import Encoder from '@/utils/encoder'
import { isNil, omitBy, extend, cloneDeep } from 'lodash'
import diagnosisSidebarStore from '@/modules/diagnosisModule/sideBar/DiagnosisSideBarStore'
import { caseState } from '@/api/resources/entityState/case-state'
import DiagnosisCaseFilterServices from '@/modules/diagnosisModule/services/DiagnosisCaseFilterServices'

export default {
    name: 'DiagnosisIndex',
    components: {
        DiagnosisSideBar
    },
    data() {
        return {
            loaded: false,
            sideBarState: diagnosisSidebarStore.state,
            sidebarSummaryInterval: null,
            sidebarSummary: null,
            encoder: new Encoder(),
            predefinedFiltersSummary: null
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        }
    },
    async created() {
        diagnosisSidebarStore.loadedConfig = false
        this.$eventHub.$on('diagnosis-sidebar-mounted', this.initDiagnosis)
        this.$eventHub.$on('update-case-consultation-summary', this.loadSidebarConsultations)
    },
    beforeDestroy() {
        if (this.sidebarSummaryInterval !== null) {
            clearInterval(this.sidebarSummaryInterval)
        }
        this.cleanSearchStateGlobalMixin()
        this.$eventHub.$off('diagnosis-sidebar-mounted', this.initDiagnosis)
        this.$eventHub.$off('update-case-consultation-summary', this.loadSidebarConsultations)
    },
    methods: {
        async initDiagnosis() {
            try {
                await Promise.all([
                    caseState.loadStates(),
                    diagnosisSidebarStore.loadCustomOptions()
                ])
                await this.loadAllSummaries()
                this.sidebarSummaryInterval = this.$_setSummaryInterval(this.loadAllSummaries)
                diagnosisSidebarStore.selectDefaultOption()
            } finally {
                this.loaded = true
            }
        },
        onClickUpdateFilter(option) {
            if (this.$refs.mainContent.onSideBarClickUpdateFilter) {
                this.$refs.mainContent.onSideBarClickUpdateFilter(option)
            }
        },
        async loadSidebarSummary() {
            const filterModel = omitBy(diagnosisSidebarStore.state.externalFilterModel, isNil)
            let situationsSummary
            if (diagnosisSidebarStore.state.config.viewAllEnabled) {
                situationsSummary = await DiagnosisCaseFilterServices.getAllCasesSummary(filterModel, this.labId)
                this.sidebarSummary = cloneDeep(extend(this.sidebarSummary, situationsSummary))
            } else {
                const params = { responsibility: diagnosisSidebarStore.state.config.responsibility?.code }
                situationsSummary = await DiagnosisCaseFilterServices.getMyOwnCasesSummary(filterModel, this.labId, params)
                this.sidebarSummary = cloneDeep(extend(this.sidebarSummary, situationsSummary))
            }
        },
        async loadSidebarConsultations() {
            const consultationsSummary = await DiagnosisCaseFilterServices.getConsultationsCasesSummary({}, this.labId)
            this.sidebarSummary = cloneDeep(extend(this.sidebarSummary, consultationsSummary))
        },
        async loadAllSummaries() {
            await this.loadSidebarSummary()
            await this.loadSidebarConsultations()
        },
        onClickAddFilter() {
            if (this.$refs.mainContent.onSideBarClickAddFilter) {
                this.$refs.mainContent.onSideBarClickAddFilter()
            }
        },
        async onViewAllToggled() {
            await this.loadSidebarSummary()
            if (this.$refs.mainContent.onViewAllToggled) {
                this.$refs.mainContent.onViewAllToggled()
            }
        },
        async onViewResponsibilityChanged() {
            await this.loadSidebarSummary()
            if (this.$refs.mainContent.onViewResponsibilityChanged) {
                this.$refs.mainContent.onViewResponsibilityChanged()
            }
        }
    }
}

</script>

<style lang="scss">

.diagnosis-case-card .state-badge{
    max-width: none !important;
}

.diagnosis-index .section-parent-checks{
  display: block !important;
}

.diagnosis-index .sr-compact-side-bar #personal-filter{
  display: none;
}

.diagnosis-index .sr-compact-side-bar #customFiltersTarget{
  display: none;
}

.case-inform .text-scroll-section{
    height: calc(100vh - 333px);
    padding-right: 5px;
    overflow-y: auto;
    overflow-x: hidden;
}

.case-inform .container{
    max-width: 100%;
}

.portion-selector .multiselect__tags{
    background: transparent;
    border-color: #fff;
}

.portion-selector .multiselect__placeholder{
    color: #fff;
}

.portion-selector .multiselect__input{
    background: transparent !important;
}

.portion-selector .multiselect__select:before{
    color: #fff;
    border-color: #fff transparent transparent;
}

.card-compact-active{
    background: vt-color(primary) !important;
}

.card-compact-active span{
    color: vt-color(white-light) !important;
}

.diagnosis-content .section-content .btn.btn__outline,
.diagnosis-content .section-content .btn.btn-primary{
    font-size: font-size(small);
}

.diagnosis-content .section-content .footer-banner .btn{
    font-size: font-size(very-small);
}

.diagnosis-content .section-content .title{
    font-size: font-size(big);
    color: vt-color(primary);
}

.case-inform .sample-icons{
    position: absolute;
    left: -54px;
    bottom: 15px;
}

.case-inform .tabs.row{
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.diagnosis-case-card{
    box-shadow: 1px 1px 5px 0 rgba(125, 125, 125, 0.34);
}

.case-inform .diagnosis-content .tab-content{
    width: 80%;
}

.case-inform .diagnosis-content .section-complementaries .col-auto{
    background: transparent;
}

/*--Screen sizes--*/
.case-col .case-content{
    overflow-y: auto;
    overflow-x: hidden;
}

.case-compact-col .case-content{
    height: calc(100vh - 179px);
}

.sample-content .sample-section{
    padding: 0 7px 5px 5px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}

.sample-content .sample-btns{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.sample-content .sample-btns .btn-badge{
    left: 0;
    right: -18px;
    top: 10px;
}

.sample-content .sample-btns .btn{
    padding: 2px;
}

.sample-content .sample-btns .btn-active{
    background-color: vt-color(primary) !important;
    color: vt-color(white-light) !important;
}

.data-col .diagnosis-content{
    height: calc(100vh - 216px);
}

.case-compact-col{
    flex: 0 0 60px;
    max-width: 60px;
}

.sample-col.col-xl-2{
    flex: 0 0 180px;
    max-width: 180px;
}

.sample-compact-col.col-xl-2{
    flex: 0 0 70px;
    max-width: 80px;
}

.diagnosis-content .carousel-min{
    display: none;
}

.diagnosis-content .carousel-large{
    display: block;
}

/*--Sizes for large screen--*/
@media (max-width: 1300px){
    .diagnosis-content .carousel-min{
        display: block;
    }

    .diagnosis-content .carousel-large{
        display: none;
    }

    .diagnosis-content .section-content .title{
        font-size: font-size(normal) !important;
        color: vt-color(primary);
    }

    .case-inform .sample-icons{
        width: 55px;
    }

    .case-col .case-content{
        overflow-y: auto;
        overflow-x: hidden;
    }

    /*.case-col.col-xl-3{
        flex: 0 0 260px;
        max-width: 260px;
    }*/

    .sample-col.col-xl-2{
        flex: 0 0 150px;
        max-width: 150px;
    }
}

/*--Sizes for laptop screen--*/
@media only screen and (max-width: 1366px) and (min-width: 1360px){
    .diagnosis-content .carousel-min{
        display: block;
    }

    .diagnosis-content .carousel-large{
        display: none;
    }

    .case-inform .sample-icons{
        left: -35px;
    }

    .case-col .case-content{
        overflow-y: auto;
        overflow-x: hidden;
    }

    .sample-col.col-xl-2{
        flex: 0 0 160px;
        max-width: 160px;
    }

    .diagnosis-content .section-content{
        height: calc(100vh - 250px) !important;
    }
}

/*--Styles for extra large screen--*/

.case-inform .btn-badge{
    position: absolute;
    top: 5px;
    left: 7px;
}

.case-inform .btn-badge .vt-nav-badge{
    right: -7px;
    bottom: 0;
}

.case-compact-col .card-body{
    padding: 0;
}

.case-compact-col .card-footer{
    border-top: none;
}

.case-compact-col .card-footer div{
    justify-content: center !important;
}

.case-compact-col .card-footer div .btn{
    margin-right: 0 !important;
}

.case-col .card-footer,
.sample-content .card-footer{
    border-top: 0;
}

.data-col .card{
    height: 100%;
}

.case-header .btn{
    padding: 0 10px;
    margin: 0 !important;
    color: vt-color(base-text) !important;
    transition: 0.2s;
}

.case-header .btn:hover{
    color: vt-color(light-grey) !important;
}

.sample-content{
    border: 0;
}

.sample-content .card-body{
    padding: 0;
}

.case-col {
.diagnosis-case-card {
> .card-body {
    padding: 0;
}
}
}

.case-inform .vertical-title{
    text-align: center;
    margin-top: 10px;
}

.case-inform .vertical-title span{
    writing-mode: vertical-lr;
    transform: rotate(180deg);
    font-size: font-size-type(font-size-regular-3);
}

.case-inform .card-visibility{
    display: none;
}

.case-inform .main-card .main-footer{
    border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.case-inform .main-card{
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
}

.case-inform .section-bubble{
    width: 6px;
    height: 6px;
    background: #f5b372;
    border-radius: 50%;
    position: absolute;
    right: 7px;
    margin-top: 5px;
}

.case-inform .pathologist{
    font-size: font-size(small);
}

.case-inform .truncated{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.case-inform .line{
    padding: 0 10px;
}

.case-inform .line div{
    width: 1px;
    height: 20px;
    background: rgba(0, 0, 0, 0.1);
}

.case-inform .comp-card{
    border: 1px solid rgba(0, 0, 0, 0.1);
    color: vt-color(dark-text);
    border-radius: 2px;
    transition: 0.2s;
    cursor: pointer;
}

.case-inform .comp-card:hover{
    background: vt-color(light-primary);
}

.case-inform .comp-btn{
    width: 100%;
    font-size: font-size(small) !important;
}

.case-inform .comp-col{
    border: 1px solid rgb(218, 218, 218);
    margin-top: 12px;
}

.case-inform .pop-sample{
    padding-left: 0;
    padding-bottom: 0;
    margin-bottom: 0;
    width: 200px;
}

.case-inform .pop-sample li{
    list-style: none !important;
    padding: 10px !important;
    border-bottom: 1px solid rgb(218, 218, 218);
}

.case-inform .portion-selector{
    padding: 0 65px;
}

.case-inform .patient-card{
    height: 40px;
    box-shadow: 1px 1px 5px 0 rgba(125, 125, 125, 0.64);
}

.case-inform .patient-card .card-info span{
    font-size: font-size(very-small);
    color: vt-color(dark-text);
}

.case-inform .patient-card .main-info i{
    font-size: font-size(big);
}

.case-inform .patient-card .main-info span{
    font-size: font-size(very-small);
    color: vt-color(dark-text);
}

.case-inform .patient-card .floating{
    right: 10px;
    top: 0;
    z-index: 1;
}

.case-inform .patient-card .card-body{
    display: flex;
    align-items: center;
    padding-right: 0;
}

.case-inform .carousel-block{
    position: absolute;
    z-index: 1;
    bottom: 7px;
    left: 86px;
    width: calc(100% - 102px);
}

.case-inform .carousel-block .content{
    overflow: hidden;
}

.case-inform .carousel-block .content .thumbs-row{
    overflow-x: auto;
    white-space: nowrap;
}

.case-inform .carousel-block .arrow-btn{
    background: rgba(0, 0, 0, 0.3);
    width: 130px;
    border-radius: 5px 5px 0 0;
    color: vt-color(white-light);
    cursor: pointer;
    transition: 0.2s;
}

.case-inform .carousel-block .arrow-btn:hover{
    background: rgba(0, 0, 0, 0.4);
}

.case-inform .carousel-block .arrow-btn.down{
    background: vt-color(primary);
}

.case-inform .carousel-block .arrow-btn.down:hover{
    background: vt-color(dark-primary);
}

.case-inform .laptop-view{
    display: none !important;
}

/* TODO Lo mantenemos de momento oculto por si volvemos a utilizarlo pronto */
/*.case-inform .diagnosis-content .section-content{
    height: calc(100vh - 240px);
    overflow-y: hidden;
    overflow-x: hidden;
}*/

.case-inform .diagnosis-content .extra-btns{
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: center;
}

.case-inform .diagnosis-content .indicator{
    position: absolute;
    margin-left: 7px;
    margin-top: 5px;
    color: vt-color(red-high);
}

.case-inform .diagnosis-content .indicator.validated{
    color: vt-color(green-radiant);
    margin-left: 10px;
}

.case-inform .btn-badge.indicator{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    left: 18px;
    top: 13px;
}

.case-inform .diagnosis-content .indicator i{
    font-size: 10px !important;
}

.case-inform .diagnosis-content .extra-btns li .btn{
    margin-right: 0 !important;
}

.case-inform .diagnosis-content .section-icon{
    color: vt-color(primary);
    font-size: font-size(big);
    transition: 0.2s;
}

.case-inform .diagnosis-content .section-col{
    height: 100%;
    background: vt-color(light-primary);
}

.case-inform .diagnosis-content .section-content .title{
    color: vt-color(primary);
    font-size: font-size(big);
}

.case-inform .data-col .card{
    border: 0;
    border-left: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0;
}

.case-inform .data-col{
    padding: 0;
}

.case-inform .case-inform .btn.btn__icon .btn__icon--primary{
    font-size: font-size(big);
}

.case-inform .audio-scroll{
    height: calc(100vh - 850px);
    overflow-y: auto;
}

.case-inform .audio-box{
    border: 1px solid rgba(0, 0, 0, 0.2);
    width: 100%;
    border-radius: 5px;
    box-shadow: 1px 1px 5px 0 rgba(125, 125, 125, 0.64);
    transition: 0.2s;
}

.case-inform .audio-selected{
    border-color: vt-color(primary);
    color: vt-color(primary);
}

.case-inform .audio-box .audio-click{
    cursor: pointer;
    transition: 0.3s;
}

.case-inform .audio-box .audio-click:hover{
    color: vt-color(primary);
}

.case-inform .audio-box .audio-click .state{
    color: vt-color(base-text);
    font-size: 10px;
}

/*--Sizes for large screen--*/
@media (max-width: 1300px){
    .case-inform .patient-card .main-info span{
        font-size: font-size(small);
    }

    .case-inform .patient-card .main-info .name-expand{
        width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .case-inform .patient-card .main-info .name-compact {
        width: 240px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .case-inform .case-inform .btn.btn__icon .btn__icon--primary{
        font-size: font-size(normal);
    }

    .case-inform .portion-selector{
        padding: 0 45px;
    }

    .case-inform .carousel-block{
        left: 66px;
        width: calc(100% - 82px);
    }
}

/*--Sizes for laptop screen--*/
@media only screen and (max-width: 1366px) and (min-width: 1360px){
    .case-inform .laptop-view{
        display: block !important;
    }

    .case-inform .general-view{
        display: none;
    }

    .case-inform .portion-selector{
        padding: 0 50px;
    }

    .case-inform .carousel-block{
        left: 60px;
        width: calc(100% - 76px);
    }

    .case-inform .patient-card .main-info .name-expand{
        width: 80%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

</style>
